import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import api from "@/lib/api";

/**
 * Renders ALL dynamic pages that have `show_on_home: true` as small preview cards.
 * Each preview links to the full page at /p/:slug.
 */
export default function DynamicPagesPreview() {
  const [pages, setPages] = useState([]);
  useEffect(() => {
    api.get("/public/pages")
      .then((r) => {
        const list = (r.data || [])
          .filter((p) => p.show_on_home)
          .sort((a, b) => (a.home_position || 50) - (b.home_position || 50));
        setPages(list);
      })
      .catch(() => setPages([]));
  }, []);

  if (pages.length === 0) return null;

  return (
    <section className="py-16 lg:py-20" style={{ background: "var(--ct-surface)" }} data-testid="dynamic-pages-preview">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-6">
          {pages.map((p) => (
            <Link
              key={p.id || p.slug}
              to={`/p/${p.slug}`}
              className="card-premium overflow-hidden group flex flex-col sm:flex-row"
              data-testid={`home-page-preview-${p.slug}`}
            >
              {p.cover_image && (
                <div className="sm:w-40 shrink-0 aspect-video sm:aspect-auto overflow-hidden">
                  <img src={p.cover_image} alt={p.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform" />
                </div>
              )}
              <div className="p-6 flex flex-col flex-1">
                {p.eyebrow && (
                  <span className="text-[10px] uppercase tracking-[0.22em] mb-2" style={{ color: "var(--ct-gold)" }}>{p.eyebrow}</span>
                )}
                <h3 className="font-serif text-2xl mb-2 leading-tight">{p.title}</h3>
                {p.subtitle && (
                  <p className="text-sm leading-relaxed flex-1 line-clamp-3" style={{ color: "var(--ct-text-muted)" }}>
                    {p.subtitle}
                  </p>
                )}
                <span className="mt-4 inline-flex items-center gap-2 text-sm font-medium" style={{ color: "var(--ct-link)" }}>
                  {p.home_cta_label || "Citește mai mult"} <ChevronRight size={14} />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
